import React from "react";
import ImageUpload from "../../components/uploads/ImageUpload";
import TypesContext from "../../contexts/types";
import Button from "../../components/buttons/Button";
import Select from "../../components/selects/Select";
import Input from "../../components/inputs/Input";

export default ({ data, setData, errors, setError, next, btnLabel, saved }) => {
  const { countries } = React.useContext(TypesContext);

  const country =
    typeof data["country"] === "string"
      ? countries.find(({ value }) => value === data["country"])
      : data["country"];

  const verifyData = () => {
    setError();
    let isOkay = true;
    if (!data["company"]) {
      setError({
        field: "company",
        message: "Please provide a correct company name",
      });
      isOkay = false;
    }
    if (!data["country"]) {
      setError({
        field: "country",
        message: "Please provide a country",
      });
      isOkay = false;
    }
    if (!data["city"]) {
      setError({
        field: "city",
        message: "Please provide a correct city",
      });
      isOkay = false;
    }
    if (
      !data["company_size"] ||
      !Number.isInteger(parseInt(data["company_size"])) ||
      parseInt(data["company_size"]) < 1
    ) {
      setError({
        field: "company_size",
        message: "Please give the number of employees in your company",
      });
      isOkay = false;
    }
    if (!data["contact_name"]) {
      setError({
        field: "contact_name",
        message: "Please provide a correct contact name",
      });
      isOkay = false;
    }
    if (!data["contact_job"]) {
      setError({
        field: "contact_job",
        message: "Please provide a correct contact job",
      });
      isOkay = false;
    }
    if (isOkay) next();
  };

  return (
    <div className="oUserForm">
      <h3>Register your project</h3>
      <div className="oUserForm_imageUpload">
        <ImageUpload
          avatar
          label="Upload your logo"
          notice="JPG or PNG, max 200 Ko"
          currentImage={data["avatar"]}
          setFile={value => setData({ field: "avatar", value })}
        />
      </div>
      <div className="oUserForm_inputs">
        <Input
          label="Name of your startup"
          required
          value={data["company"]}
          setValue={value => setData({ field: "company", value })}
          error={errors.some(({ field }) => field === "company")}
        />
        <Select
          label="Country"
          options={countries}
          required
          width="100%"
          selected={country}
          setSelected={value =>
            setData({
              field: "country",
              value: data["country"] === value ? null : value,
            })
          }
          error={errors.some(({ field }) => field === "country")}
        />
        <Input
          label="City"
          required
          value={data["city"]}
          setValue={value => setData({ field: "city", value })}
          error={errors.some(({ field }) => field === "city")}
        />
        <Input
          label="Number of employees"
          required
          value={data["company_size"]}
          type="number"
          setValue={value => setData({ field: "company_size", value })}
          error={errors.some(({ field }) => field === "company_size")}
        />
      </div>
      <h4>Contact person</h4>
      <div className="oUserForm_inputs">
        <Input
          label="First and last name"
          required
          value={data["contact_name"]}
          setValue={value => setData({ field: "contact_name", value })}
          error={errors.some(({ field }) => field === "contact_name")}
        />
        <Input
          label="Job title"
          required
          value={data["contact_job"]}
          setValue={value => setData({ field: "contact_job", value })}
          error={errors.some(({ field }) => field === "contact_job")}
        />
      </div>
      {saved ? (
        <Button big green full>
          Saved !
        </Button>
      ) : (
        <Button onClick={verifyData} big full>
          {btnLabel || "Continue"}
        </Button>
      )}
    </div>
  );
};
